import axios from 'axios'
import path from 'path'

import is from '../web/plugins/helper/is'

export const YOUR_VAPID_PUBLIC_KEY = is.getValueSetting('vapid_public_key')

/**
 * If you are using a virtual host locally for a domain other than localhost,
 * you can tell chrome to treat your custom domain as "secure".
 *
 * In the addressbar: chrome://flags/#unsafely-treat-insecure-origin-as-secure
 * Then add your domain like http://miproyecto.test
 *
 * Click enable and click the restart button.
 *
 * @param {Object|null}
 * @return {Promise|undefined}
 */
export const initSW = params => {
  if (!('serviceWorker' in navigator)) {
    // service worker isn't supported
    return
  }

  if (!('Notification' in window)) {
    // Notification isn't supported
    return
  }

  // register the service worker
  return navigator.serviceWorker.register(path.join(__dirname, 'sw.js'))
    .then(() => {
      return initPush(params)
    }).catch(err => {
      is.captureException(err)

      return err
    })
}

/**
 * @param {Object|null} params
 * @return {Promise|undefined}
 */
export const initPush = params => {
  if (!navigator.serviceWorker.ready) {
    return
  }

  return new Promise(function (resolve, reject) {
    const permissionResult = Notification.requestPermission(function (result) {
      resolve(result)
    })

    if (permissionResult) {
      permissionResult.then(resolve, reject)
    }
  }).then(permissionResult => {
    if (permissionResult === 'granted') {
      return subscribeUser(params)
    }

    return permissionResult
  })
}

/**
 * @param {Object|null} params
 * @return {Promise|undefined}
 */
export const subscribeUser = params => {
  return navigator.serviceWorker.ready
    .then(registration => {
      const applicationServerKey = is.urlBase64ToUint8Array(YOUR_VAPID_PUBLIC_KEY)
      const subscribeOptions = {
        userVisibleOnly: true,
        applicationServerKey,
      }

      return registration.pushManager.subscribe(subscribeOptions)
    })
    .then(pushSubscription => {
      storePushSubscription(pushSubscription, params)

      return pushSubscription
    })
}

/**
 * @param {Object} pushSubscription
 * @param {Object|null} form
 * @return {Promise|undefined}
 */
export const storePushSubscription = (pushSubscription, form) => {
  if (form instanceof FormData) {
    form.append('push_subscription', JSON.stringify(pushSubscription))
  } else {
    form = pushSubscription
  }

  return axios.post('/api/push_messages/push', form)
    .then(response => {
      return response
    }).catch(error => {
      is.captureException(error)

      return error
    })
}
